<template>
  <base-text-field
    :value="value"
    :label="label"
    :placeholder="placeholder"
    @input="handleInput($event)"
    v-currency="inputOptions"
    :rules="rules"
    :required="required"
    :disabled="disabled"
    ref="input"
  >
    <template #prefix>
      USD
    </template>
  </base-text-field>
</template>

<script>
import BaseTextField from "@/components/base/BaseTextField";
import { CurrencyDirective, parse, setValue } from "vue-currency-input";

const inputOptions = {
  currency: "usd",
  autoDecimalMode: true,
  distractionFree: false,
  valueAsInteger: true,
};

export default {
  components: {
    BaseTextField,
  },
  directives: {
    currency: CurrencyDirective,
  },
  props: {
    value: [String, Number],
    label: String,
    placeholder: String,
    rules: {
      type: Array,
      default: () => [],
    },
    required: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputOptions,
    };
  },
  methods: {
    handleInput(event) {
      this.$emit("input", event);
      this.$emit("update:intValue", parse(event, inputOptions));
    },
  },
  watch: {
    value(newValue) {
      if (typeof newValue === "number") {
        setValue(this.$refs.input, null);
        setValue(this.$refs.input, newValue);
      }
    },
  },
};
</script>
